import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Segurança (WI 59972): FORA do ambiente de Desenvolvimento, o console do navegador é silenciado
// para não expor token, header Authorization, comando de replay da requisição nem o corpo da
// resposta de erro do servidor. `enableDebugTools` é true SOMENTE em dev/local (false em
// Homologação e Produção). Isto neutraliza qualquer console.* — inclusive chamadas diretas
// existentes no código — de forma centralizada e à prova de regressão futura.
if (!environment.enableDebugTools) {
  const noop = (): void => { /* console silenciado fora de Desenvolvimento (WI 59972) */ };
  const methods = [
    'log', 'info', 'debug', 'warn', 'error', 'trace', 'dir', 'dirxml',
    'table', 'group', 'groupCollapsed', 'groupEnd', 'count', 'countReset',
    'time', 'timeEnd', 'timeLog', 'assert'
  ] as const;
  const target = console as unknown as Record<string, unknown>;
  for (const method of methods) {
    target[method] = noop;
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
